import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.43 4.438c.78-.586 1.484-1.29 2.03-2.11a7.7 7.7 0 0 1-2.343.625A4 4 0 0 0 19.914.688c-.781.468-1.68.82-2.578 1.015A4.1 4.1 0 0 0 14.328.414a4.1 4.1 0 0 0-4.101 4.102q0 .469.117.937a11.9 11.9 0 0 1-8.477-4.297c-.351.586-.547 1.29-.547 2.07 0 1.407.703 2.657 1.836 3.399-.664-.04-1.328-.195-1.875-.508v.04a4.11 4.11 0 0 0 3.282 4.023c-.313.078-.704.156-1.055.156-.274 0-.508-.04-.781-.078.507 1.64 2.03 2.812 3.828 2.851a8.25 8.25 0 0 1-5.078 1.758c-.352 0-.665-.039-.977-.078 1.797 1.172 3.945 1.836 6.29 1.836 7.538 0 11.64-6.21 11.64-11.64z"
    }, null, -1)
  ]))]))
}
export default { render: render }